import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function BitcoinComputer({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14.0002 17L14.5002 21M10.0002 17L9.50023 21M8.14023 21H15.8602M10.0602 9.98001V7.27001H12.7912C13.5312 7.27001 14.1412 7.87001 14.1412 8.62401C14.1412 9.36401 13.5312 9.97401 12.7812 9.97401M11.7722 6.50001V7.27001M11.7722 13.5V12.625M18.4292 17H5.57023C4.15023 17 2.99023 15.84 2.99023 14.42V5.56001C2.99023 4.14001 4.14023 2.98001 5.56023 2.98001H18.4172C19.8372 2.98001 20.9872 4.13001 20.9872 5.55001V14.4C20.9872 15.82 19.8272 16.97 18.4072 16.97L18.4292 17ZM13.1252 12.61H10.0552V9.98001H13.1152C13.8352 9.98001 14.4252 10.56 14.4252 11.29C14.4252 12.01 13.8352 12.6 13.1052 12.6L13.1252 12.61Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default BitcoinComputer;